import { Box } from '@hivebrite/design-system/Box';

import { DYNAMIC_BACKGROUND_SELECTOR_OPTIONS } from 'hb-builder/components/BuilderComponents/block/Hero/utils/constants';
import SelectSetting from 'hb-builder/components/common/SettingsLibrary/CommonSettings/SelectSetting';
import type { OnChangeSetting } from 'hb-builder/types/settings';
import type { DocumentItem } from 'hb-react/backoffice/types/builder/builderDocument';
import type { HeroItemAttributes } from 'hb-react/backoffice/types/builder/itemAttributes/heroItemAttributes';

import VideoArrangement from './VideoArrangement';

interface VideoBackgroundProps {
  canHeroBeFullWidth: boolean;
  canSetVideoBackground: boolean;
  handleBackgroundTypeChange: (arg0: any) => void;
  item: DocumentItem<HeroItemAttributes>;
  isVideoBackground: boolean;
  onChange: OnChangeSetting;
}

const VideoBackground = ({
  canHeroBeFullWidth,
  canSetVideoBackground,
  handleBackgroundTypeChange,
  isVideoBackground,
  item,
  onChange,
}: VideoBackgroundProps) => (
  <>
    {canSetVideoBackground && (
      <SelectSetting
        options={DYNAMIC_BACKGROUND_SELECTOR_OPTIONS}
        settingKey="backgroundType"
        title={s__('Builder|Content Type')}
        item={item}
        onChange={handleBackgroundTypeChange}
      />
    )}
    {isVideoBackground && (
      <>
        <Box mb={2} mt={-2}>
          {s__(
            "Builder|Recommended format is mp4 and your file can't exceed 1Go.",
          )}
        </Box>
        <VideoArrangement
          item={item}
          onChange={onChange}
          canHeroBeFullWidth={canHeroBeFullWidth}
        />
      </>
    )}
  </>
);

export default VideoBackground;
